const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const SystemAccountAdd = () => import(/* webpackChunkName: "account" */ './system/view/add.vue');
const SystemAccountPassword = () => import(/* webpackChunkName:"account" */ './system/view/password.vue');
const AppAccountActivity = () => import(/* webpackChunkName: "account" */ './app/view/activity.vue');
const AppAccountDetail = () => import(/* webpackChunkName: "account" */ './app/view/detail.vue');
const AppAccountList = () => import(/* webpackChunkName: "account" */ './app/view/index.vue');
const AppAccountTransaction = () => import(/* webpackChunkName:"account" */ './app/view/transaction.vue');

export const ROUTE_NAME_ACCOUNT = {
    SYSTEM: {
        ADD: 'SystemAccountAdd',
        PASSWORD: 'SystemAccountPassword'
    },
    APP: {
        INDEX: 'AppAccountList',
        DETAIL: 'AppAccountDetail',
        ACTIVITY: 'AppAccountActivity',
        TRANSACTION: 'AppAccountTransaction'
    }
};

export default [
    {
        path: '/system/account',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'add',
                name: ROUTE_NAME_ACCOUNT.SYSTEM.ADD,
                component: SystemAccountAdd,
                meta: { requiresAuth: true }
            },
            {
                path: 'password',
                name: ROUTE_NAME_ACCOUNT.SYSTEM.PASSWORD,
                component: SystemAccountPassword,
                meta: { requiresAuth: true }
            }
        ]
    },
    {
        path: '/app/:appId/account',
        name: 'AppAccount',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_ACCOUNT.APP.INDEX,
                component: AppAccountList,
                meta: { requiresAuth: true }
            },
            {
                path: ':accountId/detail',
                name: ROUTE_NAME_ACCOUNT.APP.DETAIL,
                component: AppAccountDetail,
                meta: { requiresAuth: true }
            },
            {
                path: 'activity',
                name: ROUTE_NAME_ACCOUNT.APP.ACTIVITY,
                component: AppAccountActivity,
                meta: { requiresAuth: true }
            },
            {
                path: ':accountId/transaction',
                name: ROUTE_NAME_ACCOUNT.APP.TRANSACTION,
                component: AppAccountTransaction,
                meta: { requiresAuth: true }
            }
        ]
    }
];
